export var ApiTokensSubjects;
(function (ApiTokensSubjects) {
    ApiTokensSubjects["Success"] = "api-token-success";
    ApiTokensSubjects["SuccessDeletion"] = "api-token-delete-success";
    ApiTokensSubjects["SuccessUpdate"] = "api-token-update-success";
    ApiTokensSubjects["Page"] = "api-tokens-page";
    ApiTokensSubjects["RoleSelect"] = "api-token-role-select";
})(ApiTokensSubjects || (ApiTokensSubjects = {}));
export var ApiTokenScope;
(function (ApiTokenScope) {
    ApiTokenScope["ReadOnly"] = "READ_ONLY";
    ApiTokenScope["Regular"] = "REGULAR";
    ApiTokenScope["Admin"] = "ADMIN";
    ApiTokenScope["Custom"] = "CUSTOM";
})(ApiTokenScope || (ApiTokenScope = {}));
//# sourceMappingURL=api-tokens.enum.js.map